type NotificationCategory = string;

export const NOTIFICATION_CATEGORIES: NotificationCategory[] = [
  'All',
  'Offers',
  'Auctions',
  'Enquiries',
];

export type Notification = {
  id: string;
  message: string;
  date: string;
  iconType: 'offer' | 'payment';
  unread: boolean;
  category: NotificationCategory;
};

// todo: replace with actual data from the backend when API is available
export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: '1',
    message: 'New offer received of $1,450,000 on 898/142 Whitehouse',
    date: 'May 12, 2023 | 11:10 PM',
    iconType: 'offer',
    unread: true,
    category: 'Offers',
  },
  {
    id: '3',
    message: 'New offer received of $1,450,000 on 898/142 Whitehouse',
    date: 'May 12, 2023 | 11:10 PM',
    iconType: 'offer',
    unread: false,
    category: 'Offers',
  },
  {
    id: '4',
    message: 'Auction ended for 12/34 Sample Street',
    date: 'May 11, 2023 | 9:00 PM',
    iconType: 'offer',
    unread: false,
    category: 'Auctions',
  },
  {
    id: '5',
    message: 'New enquiry for your property listing',
    date: 'May 10, 2023 | 2:30 PM',
    iconType: 'payment',
    unread: true,
    category: 'Enquiries',
  },
];

export const DEVICE_ID_KEY = 'fcm_device_id';
